import { useState,useEffect } from "react";
import ParentView from "../../Views/PrarentView/ParentView";
import  ShaktipethaView  from "../../Views/Temple/ShaktipethaView";
import {  useLocation, useNavigate } from "react-router-dom";
import { getAllEnabledShaktipeethAction, getAllTempleList, } from "../../store/actions/templeAction";
import { useDispatch, useSelector } from "react-redux";
function ShaktipethaScreen() {
  const navigate = useNavigate();
  const {shaktipeethList,allTempleList} = useSelector((state: any) => state.temple);
  const [shaktipeethShivlingList,setShaktipeethaShivlingList] :any = useState([])
  const dispatch: any = useDispatch();
  const location = useLocation();
  useEffect(() => {
    try {
      dispatch(getAllTempleList(null));
      if (shaktipeethList.length === 0) {
        dispatch(getAllEnabledShaktipeethAction());
      }
    } catch (error) {}
  }, [location.pathname]);

  useEffect(()=>{
    if(shaktipeethList?.length){
      const templeTypePath = location.pathname.split("/specialTemples/")
    const templeType = templeTypePath[1].toUpperCase()
    setUpdatedShaktipeethaList(templeType)}
  },[shaktipeethList,allTempleList])

  function setUpdatedShaktipeethaList(templeType:string){
    const allOrganisationList = allTempleList

    let updatedTempleList = []
    for(let i=0;i<shaktipeethList.length;i++){
      let isTempleOnborded = false
      let templeId = null
      if(shaktipeethList[i].personalInfo?.templeType.includes(templeType)){
        const shaktipeethaGplaceId = shaktipeethList[i].googlePlaceId
        const checkIfOnboarded = allOrganisationList.filter(function(item:any){return item?.googlePlaceId === shaktipeethaGplaceId})

        if(checkIfOnboarded.length>0){
          isTempleOnborded = true
          templeId = checkIfOnboarded[0].id
        }
        else{
          isTempleOnborded = false
        }

        updatedTempleList.push({...shaktipeethList[i],onboarded:isTempleOnborded,templeId:templeId})
      }
    }
    updatedTempleList = updatedTempleList.sort((a, b) => b.onboarded - a.onboarded);
    setShaktipeethaShivlingList(updatedTempleList)
  }
  const onClickNavigateToTemple = (templeId:string)=>{
    navigate(`/temples/${templeId}`)
  }
    return (
      <ParentView>
      <ShaktipethaView templeList={shaktipeethShivlingList} onClickNavigateToTemple={onClickNavigateToTemple}/>
      </ParentView>
    );
  }
  
  export default ShaktipethaScreen;
  